import { LINES } from '../constants.js'

// ============================================================================
//  hoopPosition — pozycja kosza względem linii końcowej (suwak w sekcji Kosz,
//  wzorowany na konfiguratorze oncourt.online). Offset w PŁYTKACH, krok = 1:
//    > 0 — kosz wjeżdża W GŁĄB boiska; linie liczone od obręczy (no-charge,
//          łuki za 3) idą za nim, a trumna WYDŁUŻA się do linii końcowej,
//    < 0 — kosz cofa się ZA linię końcową (w wybieg); trumna się skraca,
//      0 — pozycja standardowa (przód mocowania na linii końcowej).
//  Czysty moduł (bez THREE/DOM) — testowalny pod Node; używany przez main,
//  controls i configCodec.
// ============================================================================

// Odstęp przód tablicy → środek obręczy (FIBA: 1,575 − 1,20 = 0,375 m).
// Zgodne z modelem HoopAir D72 (przód szyby 1,084 m przy obręczy na 1,462 m).
export const BOARD_RIM_GAP = 0.375

// Rzut przedniej płaszczyzny tablicy na płytę, od linii końcowej [m]. Proste
// odcinki półkola no-charge kończą się DOKŁADNIE na tej wysokości (FIBA), a nie
// na linii końcowej. rimZ przychodzi już po offsecie suwaka, więc odcinki idą za
// koszem. Clamp do 0 — kosz cofnięty maksymalnie (tablica nad linią końcową)
// nie wypycha linii poza płytę.
export function boardFrontZ(rimZ) {
  return Math.max(0, rimZ - BOARD_RIM_GAP)
}

// Zakres offsetu (w płytkach) dla bieżącego boiska i kosza:
//   max (w głąb): linia rzutów wolnych = 19 szt + offset musi zostać w obrysie
//     boiska (lengthTiles) — trumna nigdy nie wyjeżdża poza boisko,
//   min (do tyłu): przód tablicy (obręcz − BOARD_RIM_GAP) musi zostać nad
//     boiskiem (Z ≥ 0) — tablica pozostaje „w grze", jak u konkurencji.
//   Maszt na płycie pilnuje osobno plateExtent (zaplecze rośnie z cofnięciem).
export function hoopOffsetRange({ lengthTiles, tileM, rimFromBaseline }) {
  const eps = 1e-6
  const ftTiles = Math.floor(LINES.FREE_THROW_FROM_BASELINE / tileM + eps)
  return {
    min: -Math.max(0, Math.floor((rimFromBaseline - BOARD_RIM_GAP) / tileM + eps)),
    max: Math.max(0, lengthTiles - ftTiles),
  }
}

// Offset przycięty do zakresu; wszystko, co nie jest liczbą całkowitą → 0
// (pozycja standardowa) — odporność na śmieci z zapisów/linków.
export function clampHoopOffset(tiles, { min, max }) {
  if (!Number.isInteger(tiles)) return 0
  return Math.min(max, Math.max(min, tiles))
}
